<template>
  <div class="wrap-chairman-biography">
    <Title
      :main="titleName"
      :des="descName"
    />
    <Skeleton
      v-if="isLoading"
      width="100%"
      height="720px"
    />
    <div v-if="!isLoading">
      <ContentImage
        v-for="(imgUrl, i) in imgUrls"
        :key="i"
        :imageSUrl="imgUrl"
        :imageMUrl="imgUrl"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { constantsComputed } from '@/store/helpers'

const Skeleton = () => import('@/components/Loading/Skeleton')
const Title = () => import('./Parts/Title')
const ContentImage = () => import('./Parts/ContentImage')

export default {
  components: {
    Skeleton,
    Title,
    ContentImage
  },

  data () {
    return {
      imgUrls: []
    }
  },

  computed: {
    ...constantsComputed,
    ...mapState({
      isLoading: state => state.about.isLoading,
      messageChairman: state => state.about.chairmanBios
    }),
    titleName () {
      const mConfig = this.configMap.get('messagefromchairman_title')
      return mConfig ? mConfig.name : 'Message From'
    },
    descName () {
      const mConfig = this.configMap.get('messagefromchairman_desc')
      return mConfig ? mConfig.name : 'Chairwoman'
    }
  },

  methods: {
    matchImgUrl (urls) {
      urls.forEach(chairmanBio => {
        const urls = `${this.baseURL}/storage/app/img/about/chairman/${chairmanBio.message_image}`

        this.imgUrls.push(urls)
      })
    }
  },

  created () {
    if (!this.messageChairman) {
      this.$store.dispatch('about/getChairmanBio')
    } else {
      this.matchImgUrl(this.messageChairman)
    }
  },

  watch: {
    messageChairman (data) {
      this.matchImgUrl(data)
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap-chairman-biography {
  padding: 22px 0;
}
</style>
